import { defineStore } from 'pinia';
import { enFetch } from 'Js/utils/enFetch';
import { useUserSettingsStore } from 'Js/store/useUserSettingsStore.js';
import { useAuthStore } from '@/stores/auth';
import { RequestMethods } from 'Js/types/fetch/requestMethod';
export const useStateStore = defineStore('state', {
    state: () => ({
        globalState: null,
        moduleState: {},
    }),
    getters: {},
    actions: {
        async loadConfig(moduleName, skipConfig = false) {
            const { updateState } = useUserSettingsStore();
            const enPowerAccountId = localStorage.getItem('enPowerAccountId') ?? null;
            const body = JSON.stringify({
                ModuleName: moduleName,
                EnPowerAccountId: enPowerAccountId
            });
            try {
                const config = await enFetch('/api/Configuration/GetConfigurationForUser', {
                    method: RequestMethods.Post,
                    body: body,
                });
                const globalConfigKeys = [];
                const authStore = useAuthStore();
                // First, assign the global object
                this.globalState = {
                    UserId: authStore.me?.Id ?? config.User?.Id ?? null,
                    User: authStore.me,
                    EngineUrl: config.EngineUrl,
                    AuthUrl: config.AuthUrl,
                    EnPowerAccountId: enPowerAccountId,
                    BreadcrumbInfo: [t(`engine.modules.${moduleName}`)],
                    NotificationCallbacks: [],
                    AddNotificationCallback: (item) => {
                        this.globalState?.NotificationCallbacks.push(item);
                    },
                    EnPowerAccountsForUser: config.EnPowerAccountsForUser,
                    EnFlowUrls: config.EnFlowUrls,
                    IsAuthUrl: config.IsAuthUrl,
                    IsDev: config.IsDev,
                    IsLocalApp: config.IsLocalApp,
                    AiConnectionString: config.AiConnectionString,
                    ModulePermissions: config.ModulePermissions,
                    RolesText: config.RolesText,
                    WidgetSettings: config.WidgetSettings,
                };
                if (config.AuthUrl) {
                    localStorage.setItem('authUrl', config.AuthUrl);
                }
                updateState(this.globalState);
                // Second, filter out keys from the global object and assign to module-specific state
                // This is just to not store twice the same info and divide actual logic
                for (const key in config) {
                    if (!globalConfigKeys.includes(key)) {
                        this.moduleState[key] = config[key];
                    }
                }
            }
            catch (error) {
                console.error('Failed to load configuration', error);
            }
        },
    }
});
